import { Footer } from "@excalidraw/excalidraw/index";
import React from "react";

import { isDrawolaPlusSignedUser } from "../app_constants";
import { DRAWOLA_FEATURES } from "../drawola-features";

import { DebugFooter, isVisualDebuggerEnabled } from "./DebugCanvas";
import { EncryptedIcon } from "./EncryptedIcon";

export const AppFooter = React.memo(
  ({ onChange }: { onChange: () => void }) => {
    return (
      <Footer>
        <div
          style={{
            display: "flex",
            gap: ".5rem",
            alignItems: "center",
          }}
        >
          {isVisualDebuggerEnabled() && <DebugFooter onChange={onChange} />}
          {/* DRAWOLA:CUSTOM-START SHOW_ENCRYPTED_ICON */}
          {DRAWOLA_FEATURES.SHOW_ENCRYPTED_ICON && !isDrawolaPlusSignedUser && (
            <EncryptedIcon />
          )}
          {/* DRAWOLA:CUSTOM-END */}
        </div>
      </Footer>
    );
  },
);
